<mat-form-field class="message">
  <textarea placeholder="Megjegyzés írása..." matInput #input [escapeAwareMaxLength]="1000" [value]="value.toString()" (input)="valueChange.emit(input.value)"></textarea>
  <mat-hint align="end">{{input.value.length}}/1000</mat-hint>
</mat-form-field>
